import Vue from 'vue'
import App from './App.vue'
import { router } from './_helpers'
import { store } from './_store'
import jQuery from 'jquery'
import i18n from './_helpers/i18n'

// Import Vue Bootstrap Datetime Picker
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import fieldPhone from './components/Common/fieldPhone'
import fieldDateNative from './components/Common/fieldDateNative'

Vue.component('fieldPhone', fieldPhone)
Vue.component('fieldDateNative', fieldDateNative)
Vue.use(datePicker)

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'icon-clock',
    date: 'icon-calendar',
    up: 'icon-arrow-up',
    down: 'icon-arrow-down',
    previous: 'icon-arrow-left',
    next: 'icon-arrow-right',
    today: 'icon-calendar-check-o',
    clear: 'icon-trash',
    close: 'icon-times-circle',
  },
})

import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)

import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

import VModal from 'vue-js-modal'
Vue.use(VModal)

// Import Vue ToogleButton
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

// Import Vue Sweet Alert 2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2)

// Import Vue Multiselect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('vue-multiselect', Multiselect)

// Import Vue html2canvas for vue
import VueHtml2Canvas from 'vue-html2canvas'
Vue.use(VueHtml2Canvas)

// Import Bootstrap Framework
import 'bootstrap'
//import 'bootstrap/dist/css/bootstrap.min.css'
require('./assets/css/bootstrap.min.css')

import './registerServiceWorker'

import sanitizeHTML from 'sanitize-html'
Vue.prototype.$sanitize = sanitizeHTML

import { ValidationProvider } from 'vee-validate'
Vue.component('ValidationProvider', ValidationProvider)

import moment from "moment";

// Import Fonts and Animate
require('./assets/fonts/style.css')
require('./assets/css/animate.css')

// Import custom styles
require('./assets/css/styles.css')
require('./assets/css/sassComponents.css')
require('./assets/css/custom.css')

import deviceMixin from './mixins/deviceMixin'

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^elevenlabs-/];

Vue.filter('moment', (...args) => {
      args = Array.prototype.slice.call(args);
      const input = args.shift();
      let date;

      if (Array.isArray(input) && typeof input[0] === 'string') {
        // If input is array, assume we're being passed a format pattern to parse against.
        // Format pattern will accept an array of potential formats to parse against.
        // Date string should be at [0], format pattern(s) should be at [1]
        date = moment(input[0], input[1], true);
      } else if (typeof input === 'number') {
        if (input.toString().length < 12) {
          // If input is an integer with fewer than 12 digits, assume Unix seconds...
          date = moment.unix(input);
        } else {
          // ..otherwise, assume milliseconds.
          date = moment(input);
        }
      } else {
        // Otherwise, throw the input at moment and see what happens...
        date = moment(input);
      }

      if (!input || !date.isValid()) {
        // Log a warning if moment couldn't reconcile the input. Better than throwing an error?
        console.warn('Could not build a valid `moment` object from input.');
        return input;
      }

      function parse(...args) {
        args = Array.prototype.slice.call(args);
        const method = args.shift();

        switch (method) {
          case 'add': {
            /*
            * Mutates the original moment by adding time.
            * http://momentjs.com/docs/#/manipulating/add/
            */

            const addends = args.shift()
              .split(',')
              .map(Function.prototype.call, String.prototype.trim);
            const obj = {};

            for (let n = 0; n < addends.length; n++) {
              const addend = addends[n].split(' ');
              obj[addend[1]] = addend[0];
            }
            date.add(obj);
            break;
          }

          case 'subtract': {
            /*
            * Mutates the original moment by subtracting time.
            * http://momentjs.com/docs/#/manipulating/subtract/
            */

            const subtrahends = args.shift()
              .split(',')
              .map(Function.prototype.call, String.prototype.trim);
            const obj = {};

            for (let n = 0; n < subtrahends.length; n++) {
              const subtrahend = subtrahends[n].split(' ');
              obj[subtrahend[1]] = subtrahend[0];
            }
            date.subtract(obj);
            break;
          }

          case 'from': {
            /*
            * Display a moment in relative time, either from now or from a specified date.
            * http://momentjs.com/docs/#/displaying/fromnow/
            */

            let from = 'now';
            let removeSuffix = false;

            if (args[0] === 'now') args.shift();
            // If valid, assume it is a date we want the output computed against.
            if (moment(args[0]).isValid()) from = moment(args.shift());

            if (args[0] === true) {
              args.shift();
              removeSuffix = true;
            }

            if (from !== 'now') {
              date = date.from(from, removeSuffix);
            } else {
              date = date.fromNow(removeSuffix);
            }
            break;
          }

          case 'diff': {
            /*
            * Mutates the original moment by doing a difference with another date.
            * http://momentjs.com/docs/#/displaying/difference/
            */

            let referenceTime = moment();
            let units = '';
            let float = false;

            if (moment(args[0]).isValid()) {
              // If valid, assume it is a date we want the output computed against.
              referenceTime = moment(args.shift());
            } else if (args[0] === null || args[0] === 'now') {
              // If null or 'now', remove argument and proceed with default referenceTime.
              args.shift();
            }

            if (args[0]) units = args.shift();

            if (args[0] === true) float = args.shift();

            date = date.diff(referenceTime, units, float);
            break;
          }

          case 'calendar': {
            /*
            * Formats a date with different strings depending on how close
            * to a certain date (today by default) the date is.
            * http://momentjs.com/docs/#/displaying/calendar-time/
            */

            let referenceTime = moment();
            let formats = {};

            if (moment(args[0]).isValid()) {
              // If valid, assume it is a date we want the output computed against.
              referenceTime = moment(args.shift());
            } else if (args[0] === null || args[0] === 'now') {
              // If null or 'now', remove argument and proceed with default referenceTime.
              args.shift();
            }

            if (typeof args[0] === 'object') formats = args.shift();

            date = date.calendar(referenceTime, formats);
            break;
          }

          case 'utc': {
            /*
            * Mutates the original moment by converting to UTC
            * https://momentjs.com/docs/#/manipulating/utc/
            */
            date.utc();
            break;
          }

          case 'timezone': {
            /*
            * Mutates the original moment by converting to a new timezone.
            * https://momentjs.com/timezone/docs/#/using-timezones/converting-to-zone/
            */
            date.tz(args.shift());
            break;
          }

          default: {
            /*
            * Formats a date by taking a string of tokens and replacing
            * them with their corresponding values.
            * http://momentjs.com/docs/#/displaying/format/
            */

            const format = method;
            date = date.format(format);
          }
        }

        if (args.length) parse.apply(parse, args);
      }

      parse.apply(parse, args);

      return date;
    });

   

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  var splitStr = value.toLowerCase().split(' ')
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  return splitStr.join(' ')
})

Vue.filter('breakLines', function (value) {
  if (!value) return ''
  let ret = ''
  var groups = value.split(',')
  return groups.join('<br>')
})

Vue.filter('firstLetters', function (string) {
  if (!string) return ''
  var matches = string.match(/\b(\w)/g)
  return matches.join('')
})
Vue.filter('firstLetter', function (string) {
  if (!string) return ''
  return string.charAt(0).toUpperCase()
})

Vue.filter('formatDate', function (datetime) {
  if (!datetime) return ''
  function pad(s) {
    return s < 10 ? '0' + s : s
  }
  var dateArray = datetime.split(/-|\s|:/)
  var date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2])
  return [
    pad(date.getDate()),
    pad(date.getMonth() + 1),
    date.getFullYear(),
  ].join('-')
})

Vue.filter('formatContactName', function (contactName, email) {
  if (!contactName) return ''
  if (contactName.match(RegExp('\\b' + 'Generic' + '\\b', 'ig'))) {
    if (!email) return ''
    let name = email.split('@')[0]
    name = name.replace(/[_.-]/gi, ' ')
    name = name.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) =>
      match.toUpperCase(),
    )
    return name
  } else return contactName
})

Vue.filter('formatDatetime', function (datetime) {
  if (!datetime) return ''
  function pad(s) {
    return s < 10 ? '0' + s : s
  }
  var time = datetime.split(' ')[1]
  var dateArray = datetime.split(/-|\s|:/)
  var date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2])
  return (
    `${time} hs. (` +
    [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join(
      '-',
    ) +
    ')'
  )
})

Vue.filter('formatDatePretty', function (datetime) {
  if (!datetime) return ''
  function pad(s) {
    return s < 10 ? '0' + s : s
  }
  var time = datetime.split(' ')[1]
  time = time.substring(0, 5)
  var dateArray = datetime.split(/-|\s|:/)
  var date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2])
  date = date.toDateString()
  return date + ` ${time} hs. `
})

Vue.filter('invoiceFormat', function (invoice) {
  invoice = invoice.toString().padStart(10, '0')
  return invoice
})

Vue.filter('VAT', function (amount) {
  let vat = (amount * 0.2).toFixed(2)
  return vat
})
Vue.filter('TTC', function (amount) {
  let vat = (amount * 0.2).toFixed(2)
  return (parseFloat(amount) + parseFloat(vat)).toFixed(2)
})

import VueFormGenerator from 'vue-form-generator'
Vue.use(VueFormGenerator)
Vue.component('vue-form-generator', VueFormGenerator.component)

VueFormGenerator.validators.emailValidator = function (value, field, model) {
  if (value != undefined) {
    let re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/
    if (!re.test(value)) {
      let fieldLabel =
        field == undefined || field.label == undefined ? 'Email' : field.label
      return [i18n.t('lang.validation.email', { field_name: fieldLabel })]
    }
  }

  return []
}

VueFormGenerator.validators.emailListValidator = function (
  value,
  field,
  model,
) {
  let errorList = []
  if (value != undefined) {
    value = value.split(',')
    value.forEach((email) => {
      errorList = VueFormGenerator.validators.emailValidator(
        email.trim(),
        field,
        model,
      )
      if (errorList.length > 0) {
        return false // break
      }
      return true // continue
    })
  }
  return errorList
}
VueFormGenerator.validators.confirmPasswordValidator = function (
  value,
  field,
  model,
) {
  if (value != model.password) {
    return [i18n.t('lang.validation.confirmpassword')]
  } else {
    return []
  }
}
VueFormGenerator.validators.validatePassword = function (value, field, model) {
  let re = /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,}).{6,16}$/
  if (!re.test(value)) {
    return [i18n.t('lang.validation.password')]
  } else {
    return []
  }
}
VueFormGenerator.validators.siretValidator = function (value, field, model) {
  if (value === undefined || value === null || String(value).trim() === '') {
    return field.required ? [i18n.t('lang.label.required')] : []
  }
  const digits = String(value).replace(/\s/g, '')
  if (!/^(\d{9}|\d{14})$/.test(digits)) {
    return [i18n.t('lang.validation.siret')]
  }
  return []
}
VueFormGenerator.validators.notAcceptNumberOrEmail = function (value, field, model) {
  const notNumber = /^([^0-9]*)$/
  const notUrl = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
  if (!notNumber.test(value) || value.match(/@/gi) || value.match(notUrl)) {
    return [i18n.t('lang.validation.not_number_and_email')]
  }
  return []
}
VueFormGenerator.validators.numberBetweenValidator = function (
  value,
  field,
  model,
) {
  if (isNaN(value) || value < field.min || value > field.max) {
    return [
      this.$t('lang.validation.between', { min: field.min, max: field.max }),
    ]
  }
  return []
}

function capitalizeFirstLetter(string) {
  if (string !== undefined) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  return ''
}

const currentUrl = window.location.href;
if (process.env.VUE_APP_ENV == 'production' && !currentUrl.includes("mycalendar")) {

  let hubspot = document.createElement('script')
    hubspot.setAttribute('type', 'text/javascript')
    hubspot.setAttribute('id', 'hs-script-loader')
    hubspot.setAttribute('async', 'async')
    hubspot.setAttribute('defer', 'defer')
    hubspot.setAttribute('src', '//js-eu1.hs-scripts.com/26298630.js')
    document.head.appendChild(hubspot)

  const user = store.state.authentication.user;

  if(!currentUrl.includes("client-service-proposal") && user != null && !['1', '2', '4'].includes(user.role_id)) {
    let googletag = document.createElement('script')
    googletag.setAttribute('type', 'text/javascript')
    googletag.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://analytics.oliverlist.com/hcbwzpjqmgow9oi.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-W2BBSZ7');"
    document.head.appendChild(googletag)
  }



  if (store.state.authentication.user != null && store.state.authentication.user.role_id != '1') {
    let hubspot = document.createElement('script')
    hubspot.setAttribute('type', 'text/javascript')
    hubspot.setAttribute('id', 'hs-script-loader')
    hubspot.setAttribute('async', 'async')
    hubspot.setAttribute('defer', 'defer')
    hubspot.src = '//js-eu1.hs-scripts.com/26298630.js'
    document.body.appendChild(hubspot)
    let hubtoken = store.state.authentication.user.id
    if (store.state.authentication.user.hubspot_token !== null) {
      hubtoken = store.state.authentication.user.hubspot_token
    }
    window.hsConversationsSettings = {
      identificationEmail: store.state.authentication.user.email,
      identificationToken: hubtoken,
    }

          // rellena los valores de dataLayer para google tag manager
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'page_view2',
        'customer_id': store.state.authentication.user.id,
        'user_Name': store.state.authentication.user.name,
        'user_LastName': store.state.authentication.user.lastname,
        'user_Mail': store.state.authentication.user.email,
        'user_Phone': store.state.authentication.user.phone,
        'user_Country': store.state.authentication.user.lang_code,
        'user_City': store.state.authentication.user.client_city,
        'user_postalcode': store.state.authentication.user.client_postal_code,
        'langue': store.state.authentication.user.lang_code
      });
 
  }


}
//Funcion para validar el cambio de loggin de diferentes users
window.addEventListener('storage', (event) => {
  if (event.key === 'authState') {
    const newAuthState = localStorage.getItem('authState');
    const currentAuthState = btoa(unescape(encodeURIComponent(JSON.stringify(store.state.authentication))));

    // Si los estados son diferentes, recarga la página
    if (newAuthState !== currentAuthState) {
      window.location.href = '/';     
    }
  }
});

Vue.mixin(deviceMixin)

new Vue({
  router,
  store,
  i18n,
  beforeMount() {
    window.addEventListener('load', this.onLoad)
    window.addEventListener('beforeunload', this.onUnload)
  },
  beforeDestroy() {
    window.removeEventListener('load', this.onLoad)
    window.removeEventListener('beforeunload', this.onUnload)
  },
  methods: {
    onLoad(event) {},
    onUnload(event) {
      if (store.state.authentication.user != undefined) {
        window.localStorage.setItem(
          'xkhx$$',
          btoa(
            unescape(
              encodeURIComponent(JSON.stringify(store.state.authentication)),
            ),
          ),
        )
      }
    },
  },

  render: (h) => h(App),
}).$mount('#app')
